import AboutUs from "./components/AboutUs";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import TextScroll from "./components/TextScroll";
import TheTeam from "./components/TheTeam";
import "aos/dist/aos.css";
import AOS from "aos";
import { useEffect } from "react";
function App() {
	useEffect(() => {
		AOS.init({ duration: 1400, offset: 300 });
	}, []);

	return (
		<div className="flex flex-col w-full">
			<Navbar />
			<Hero />
			<TextScroll />
			<AboutUs />
			<TheTeam />
			<FAQ />
			<Footer />
		</div>
	);
}

export default App;
